import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import * as TYPES from './constants';
import {
  requestSkillsData,
  receiveSkillsData,
  handleSkillsDataError,
} from './actions';
const initialState = {
  request: null,
  data: null,
  error: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_SKILLS_DATA:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_SKILLS_DATA:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.SKILLS_DATA_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchSkillsData = () => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestSkillsData());
  try {
    return fetch(`${API.student.skillsData}`, config)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        dispatch(receiveSkillsData(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleSkillsDataError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleSkillsDataError(err));
  }
};
